import React from 'react';
import Playlist from './playlist';
import './App.css';

function App() {
  return (
    <div className="App">
      <Playlist/>
    </div>
  );
}

export default App;
